import { ComponentType, FC, ReactNode, Suspense } from "react";
import lazyWithRetry from "@/utils/lazy-with-retry";
import RouteFallback from "./RouteFallback";

/**
 * Gives a route element its own Suspense boundary, so a nested navigation only
 * falls back in the subtree that is actually loading instead of blanking the
 * whole page. Use it directly for routes that need props passed in.
 */
export const SuspendedRoute = ({ children }: { children: ReactNode }) => (
  <Suspense fallback={<RouteFallback />}>{children}</Suspense>
);

/** Code-splits a props-less route component and wraps it in {@link SuspendedRoute}. */
function lazyRoute(
  factory: () => Promise<{ default: ComponentType<object> }>
): FC {
  const Lazy = lazyWithRetry(factory);

  const LazyRoute = () => (
    <SuspendedRoute>
      <Lazy />
    </SuspendedRoute>
  );

  return LazyRoute;
}

export default lazyRoute;
